import React from 'react';
import { Outlet } from 'react-router-dom';
import ClientSidebar from '../components/ClientSidebar'; // Sidebar

const ClientLayout = () => {
  return (
    <div style={{ backgroundColor: '#DFEAF5' }} className="allmyclientpage">
      <ClientSidebar /> {/* Sidebar à gauche */}
      <div className="wrapper d-flex flex-column min-vh-100 p-1 p-md-4 dashbbo">
        <div className="body flex-grow-1" style={{ backgroundColor: '#DFEAF5', width:'100%' , height:'100%', paddingBottom:"40px" }}>
          <Outlet /> {/* Affichage des pages à l'intérieur de cet espace */}
        </div>
      </div>
    </div>
  );
}
 
export default ClientLayout;
